/* ============================================================================
   Private Cellar Selection — one-click allocation request from a producer card
   assets/allocation-request.js

   Loaded by templates/page.allocation-calendar.liquid and
   templates/page.allocation-producers.liquid. The producer page deliberately
   does NOT load it: that page has its own copy of this logic because it also
   handles per-wine requests and shares button state with the registration form.

   WHAT A CLICK DOES. It writes a WHOLE-ESTATE row (wine = null) to the
   public.allocation_requests ledger through the allocation-request edge
   function, which resolves the producer server-side from its handle and then
   fires the Klaviyo event and list subscription. This is the same call the
   producer page's "Request whole estate" button makes, so the two cannot
   produce duplicate rows — the ledger is unique on
   (lower(email), producer_handle, coalesce(wine,'')) and the RPC upserts.
   Clicking + on a card and clicking "Request whole estate" on the producer page
   are the same request, and each shows the other's state.

   NO localStorage, deliberately — the same decision the producer page made.
   State is read back from the ledger on load, so a card that reads "Requested"
   reads it on every device rather than only in the browser that clicked it. An
   anonymous visitor is asked for an email inline, beside the button they
   clicked, rather than being sent to a form on another page: the whole point of
   the + is that it does not make anybody navigate.

   ONE PRODUCER, SEVERAL CARDS. The calendar lists each green producer in the
   "Current release available now" shortlist AND again under its release month,
   so marking the clicked button alone would leave the same estate reading
   "+ Request" a screen further down. Every mark is therefore applied by handle
   across the whole page.

   SOURCE. The payload sends source:"producer_card", and the edge function's
   allowedSources list HAS included it since v7 (9 Aug), alongside write_in and
   vintage_request; the table's CHECK constraint was widened in the same
   migration. Attribution is live and correct — 119 producer_card rows on the
   first campaign day. The previous version of this comment said the value was
   still being coerced to "producer_page", which was true when written and has
   since misled at least one audit. If you change allowedSources again, change
   this comment in the same breath.

   CORS is locked to https://shop.lamontscott.com.au. Previewing this page on
   the myshopify.com domain will fail the fetch with a CORS error that looks
   like a broken button. Preview on the shop domain.
   ========================================================================= */
(function(){
  var cfgEl=document.getElementById('ap-req-cfg'); if(!cfgEl){return;}
  var CFG={}; try{CFG=JSON.parse(cfgEl.textContent||'{}');}catch(e){return;}
  if(!CFG.fnUrl||!CFG.fnKey){return;}

  /* ---- instrumentation, F8-minimum (10 Aug) -----------------------------
     Klaviyo onsite (klaviyo.js, company UWDXYu) is already loaded storewide and
     carries its own __kla_id cookie, so it attaches these to an anonymous
     visitor and stitches them to the profile later when the same browser
     identifies. That is precisely why the micro-funnel goes through klaviyo.js
     rather than through the edge function: request_click and request_form_shown
     happen BEFORE there is an email address to key a server-side event on.

     Content blockers will drop some of these, as they drop all a.klaviyo.com
     traffic. That costs absolute volume but not the ratios, because all four
     events travel the same path and are lost at the same rate — and the ratios
     are the entire point of the funnel. Absolute registration counts should
     still be read from the allocation_requests ledger, which is server-side and
     unblockable.

     Never throws and never blocks the action being measured. */
  function ev(name, props){
    try{
      if(window.klaviyo && typeof window.klaviyo.push === 'function'){
        window.klaviyo.push(['track', name, props || {}]);
      }
    }catch(e){}
  }
  function evProducer(b){
    return {
      'Producer': b ? (b.getAttribute('data-producer-name') || '') : '',
      'Producer Handle': b ? (b.getAttribute('data-producer-handle') || '') : '',
      'Signed in': !!CFG.email
    };
  }

  var btns=[].slice.call(document.querySelectorAll('[data-ap-request]'));
  /* The write-in form is a separate job this file also does. The requests page
     carries the form and no + buttons at all, so neither may gate the other. */
  var wiForm=document.querySelector('[data-ap-writein]');
  if(!btns.length && !wiForm){return;}

  /* Anything that changes the ledger announces it, so a page rendering the
     customer's list (My Allocation Requests) can redraw from the rows the
     function just returned rather than refetching or reloading. */
  function announce(requests){
    try{
      document.dispatchEvent(new CustomEvent('ap:requests-updated',{detail:{requests:requests||[]}}));
    }catch(e){}
  }

  /* One email-capture strip for the page, built here rather than in Liquid so
     neither template has to carry markup it does not otherwise need, and so it
     can never be rendered inside a container that is hidden at the time. It is
     moved next to whichever button was clicked. Both card action rows wrap, and
     the strip is width:100%, so it lands on its own line under the button. */
  var ui=document.createElement('div');
  ui.className='ap-req-ui';
  ui.innerHTML=
    '<div class="ap-req-mail">'+
      '<input type="email" class="ap-req-email" autocomplete="email" placeholder="Your email address" aria-label="Your email address">'+
      '<button type="button" class="ap-plus ap-req-go">Save request</button>'+
    '</div>'+
    '<p class="ap-req-msg" role="status" aria-live="polite"></p>';
  var mail=ui.querySelector('.ap-req-mail'),
      input=ui.querySelector('.ap-req-email'),
      go=ui.querySelector('.ap-req-go'),
      msg=ui.querySelector('.ap-req-msg');
  var pending=null;

  function say(t){ msg.textContent=t||''; }

  function callFn(body){
    return fetch(CFG.fnUrl,{method:'POST',
      headers:{'Content-Type':'application/json','Authorization':'Bearer '+CFG.fnKey},
      body:JSON.stringify(body)});
  }
  function read(r){ return r.json().catch(function(){return {};}).then(function(j){return {r:r,j:j};}); }
  function who(email,first,last){
    var c={email:email};
    if(first){c.first_name=first;}
    if(last){c.last_name=last;}
    if(CFG.customerId){c.id=CFG.customerId;}
    return c;
  }

  function mark(b){
    b.classList.remove('busy');
    b.classList.add('on');
    var i=b.querySelector('.ap-plus__ico'), x=b.querySelector('.ap-plus__txt');
    if(i){i.textContent='✓';}
    if(x){x.textContent=(b.getAttribute('data-ap-mode')==='notify')?'We will let you know':'Interest registered';}
    b.setAttribute('aria-disabled','true');
    b.setAttribute('aria-label','Already in your allocation requests');
  }
  /* Mark every card for this estate, not just the one that was clicked. */
  function markHandle(handle){
    if(!handle){return;}
    btns.forEach(function(b){
      if(b.getAttribute('data-producer-handle')===handle){mark(b);}
    });
  }
  /* Read the ledger's own answer. Only a row with wine null counts here: a
     customer who has asked for one specific wine has NOT asked for the whole
     estate, and the + on a card is the whole-estate request. Marking it from a
     single-wine row would tell them they had done something they had not. */
  function applyList(requests){
    if(!requests||!requests.length){return;}
    requests.forEach(function(r){
      if(r.wine){return;}
      /* 4.11 (14 Oct). A row the desk has moved on to offered, accepted or
         allocated is still this customer's interest, so the control stays
         marked; declined is the one status that frees it again. */
      if(r.status==='declined'){return;}
      markHandle(r.producer_handle);
    });
  }

  function send(btn,email,first,last){
    var handle=btn.getAttribute('data-producer-handle')||'';
    var name=btn.getAttribute('data-producer-name')||'that producer';
    /* Stage 4 (14 Oct). The producer collection panel reuses this file and
       says where it lives and which promise it makes: source collection_page,
       and mode notify for a producer outside the Allocation Program. */
    var src=btn.getAttribute('data-ap-source')||'producer_card';
    var notify=btn.getAttribute('data-ap-mode')==='notify';
    if(!handle){return;}
    btn.classList.add('busy');
    say('Saving…');
    return callFn({action:'add',producer_handle:handle,wine:'',appellation:'',
                   source:src,customer:who(email,first,last)})
      .then(read)
      .then(function(o){
        if(o.r.ok&&o.j&&o.j.ok){
          markHandle(handle);
          applyList(o.j.requests);
          announce(o.j.requests);
          ev('request_submit', {'Producer': name, 'Producer Handle': handle,
                                'Source': src, 'Signed in': !!CFG.email});
          say(notify
            ? 'Done. We will email '+email+' when new stock from '+name+' arrives.'
            : 'Interest registered for '+name+'. We will contact you at '+email+' before the release is offered. Registering does not reserve wine or guarantee an allocation.');
        }else{
          btn.classList.remove('busy');
          console.log('Allocation request error',o.r.status,o.j);
          say('Sorry, that did not save. Please try again, or contact the store and we will add it for you.');
        }
      })
      .catch(function(){
        btn.classList.remove('busy');
        say('Sorry, that did not save. Please try again, or contact the store and we will add it for you.');
      });
  }

  btns.forEach(function(b){
    b.addEventListener('click',function(e){
      /* The directory card is covered by a stretched link so the whole card is
         clickable; without this the + would also navigate to the producer page. */
      e.preventDefault(); e.stopPropagation();
      if(b.classList.contains('on')||b.classList.contains('busy')){return;}
      ev('request_click', evProducer(b));
      /* The control sits in the card's top-right header row, which is the wrong
         place for a full-width email field. Each card is marked with
         data-ap-req-host, so the strip lands at the foot of the card the
         customer clicked instead of squeezing the header. Falls back to the
         button's own parent if a card ever forgets the attribute. */
      var host=(b.closest&&b.closest('[data-ap-req-host]'))||b.parentNode;
      if(host){host.appendChild(ui);}
      say('');
      if(CFG.email){ send(b,CFG.email,CFG.firstName,CFG.lastName); return; }
      pending=b;
      ev('request_form_shown', evProducer(b));
      mail.classList.add('on');
      say(b.getAttribute('data-ap-mode')==='notify'?'Add your email and we will let you know when it is back.':'Add your email and we will save this request.');
      input.focus();
    });
  });

  go.addEventListener('click',function(e){
    e.preventDefault(); e.stopPropagation();
    var v=(input.value||'').trim();
    if(!v||v.indexOf('@')<1||v.indexOf('.')<0){say('Please enter a valid email address.');input.focus();return;}
    if(!pending){return;}
    mail.classList.remove('on');
    send(pending,v,'','');
    pending=null;
  });
  input.addEventListener('keydown',function(ev){
    if(ev.key==='Enter'){ev.preventDefault();go.click();}
  });
  /* The strip sits inside a card that is itself a link on the directory page. */
  ui.addEventListener('click',function(e){e.stopPropagation();});

  /* True state on load. Signed-in only: an anonymous visitor has no identity to
     look up, so nothing is marked until they submit — honest rather than
     optimistic. One request for the whole page, however many cards it holds. */
  if(CFG.email){
    callFn({action:'list',customer:who(CFG.email,CFG.firstName,CFG.lastName)})
      .then(read)
      .then(function(o){ if(o.r.ok&&o.j&&o.j.ok){applyList(o.j.requests);} })
      .catch(function(){});
  }

  /* ---------------------------------------------------------- write-ins ---
     An estate Lamont's does not carry. The customer supplies a NAME; the edge
     function derives the handle from it server-side and forces an `unlisted-`
     prefix, so nothing here needs to — and must not — invent one. A wine and a
     vintage can ride along, because "the 2016 Le Bourg" is the request people
     actually have, not "Clos Rougeard, some time, some wine".

     The form is progressive: producer is the only required field beyond an
     email, and the email field is rendered by Liquid only when the visitor is
     signed out. Native `required` does the first pass of validation, so this
     only handles what the browser cannot. */
  if(wiForm){
    var wiMsg=wiForm.querySelector('.ap-wi__msg');
    var wiBtn=wiForm.querySelector('button[type="submit"]');
    var wiFields=wiForm.querySelector('.ap-wi__grid');

    function wiSay(t,done){
      if(!wiMsg){return;}
      wiMsg.textContent=t||'';
      wiMsg.classList.toggle('is-done',!!done);
    }
    function val(name){
      var el=wiForm.querySelector('[name="'+name+'"]');
      return el?(el.value||'').trim():'';
    }

    wiForm.addEventListener('submit',function(e){
      e.preventDefault();
      var producer=val('producer');
      if(!producer){wiSay('Please tell us which estate you are after.');return;}

      var email=CFG.email||val('email');
      if(!email||email.indexOf('@')<1||email.indexOf('.')<0){
        wiSay('Please add a valid email address so we can come back to you.');
        return;
      }

      var label=[producer, val('wine'), val('vintage')].filter(Boolean).join(', ');
      if(wiBtn){wiBtn.disabled=true;wiBtn.textContent='Adding…';}
      wiSay('');

      callFn({action:'add',
              producer_write_in:producer,
              wine:val('wine'),
              vintage:val('vintage'),
              source:'write_in',
              customer:who(email,CFG.firstName,CFG.lastName)})
        .then(read)
        .then(function(o){
          if(wiBtn){wiBtn.disabled=false;wiBtn.textContent='Add to my list';}
          if(o.r.ok&&o.j&&o.j.ok){
            announce(o.j.requests);
            /* The form is replaced rather than merely cleared: leaving an empty
               form under a success message invites the same thing being sent
               twice, and there is nothing left to do here. */
            if(wiFields){wiFields.hidden=true;}
            if(wiBtn){wiBtn.hidden=true;}
            ev('request_submit', {'Producer': producer, 'Source': 'write_in',
                                  'Signed in': !!CFG.email});
            wiSay('Added '+label+'. We will come back to you if it turns up — that can be a month or a year, depending on the wine.',true);
            wiForm.reset();
          }else{
            console.log('Allocation write-in error',o.r.status,o.j);
            wiSay(o.j&&o.j.error==='bad_producer_name'
              ? 'We could not read that as an estate name. Try the name as it appears on the label.'
              : 'Sorry, that did not save. Please try again, or contact the store and we will add it for you.');
          }
        })
        .catch(function(){
          if(wiBtn){wiBtn.disabled=false;wiBtn.textContent='Add to my list';}
          wiSay('Sorry, that did not save. Please try again, or contact the store and we will add it for you.');
        });
    });
  }

  /* shop_click. Delegated and in the capture phase, because the control is a
     plain link that navigates away — there is no element here that owns it.
     The producer identity is read from the request button in the same card, so
     no markup change is needed on the link itself. Some of these will be lost
     to the navigation; treated as a floor, not a count. */
  document.addEventListener('click', function(e){
    var a = (e.target && e.target.closest) ? e.target.closest('.cal-act--primary') : null;
    if(!a){return;}
    var card = a.closest('[data-ap-req-host]');
    var rb = card ? card.querySelector('[data-ap-request]') : null;
    ev('shop_click', evProducer(rb));
  }, true);
})();
